import { createContext } from 'react';

/** Same handler as desktop `<Steps onClick />` — used by mobile preview onboarding strip. */
export const ChatbotOnboardingStepClickContext = createContext(null);
